import moment from 'moment';
import { STATUS_DIAPLAY_MAP } from '../constants/statusDisplayMap';
import { buildComment } from './buildComment';

export const getTableRows = (data, onActionClick) => {
	return data.map((row, idx) => (
		<tr>
			<td>{idx + 1}.</td>
			<td>{row.customer.phoneNo}</td>
			<td>{row.consultant.name}</td>
			<td>{row.market.short.toUpperCase()}</td>
			<td>{STATUS_DIAPLAY_MAP[row.shipping.status]}</td>
			<td>{moment(row.shipping.statusDate).format('YYYY-MM-DD HH:mm')}</td>
			<td>{buildComment(row.ccCalls?.[0])}</td>
			<td>
				{row.ccCalls?.[0]?.date &&
					moment(row.ccCalls[0].date).format('YYYY-MM-DD HH:mm')}
			</td>
			<td>{buildComment(row.ccCalls?.[1])}</td>
			<td>
				{row.ccCalls?.[1] &&
					moment(row.ccCalls?.[1]?.date).format('YYYY-MM-DD HH:mm')}
			</td>
		</tr>
	));
};
